import BranchIoSdk from './BranchIoSdk';
import TaggedLogger from '../debug/tagged-logger';

/**
 * BranchIo main implementation.
 */
class BranchIo {
  /**
   * Construcs
   * @param {string} key - branch ios app_key
   */
  constructor(key) {
    this.logger = new TaggedLogger('BranchIo');
    this.sdk = new BranchIoSdk(key);
  }
}

export default BranchIo;



// WEBPACK FOOTER //
// ./Library/1.0/common/branch-io/BranchIo.js